// Notification bell — green when subscribed, click-to-enable when default,
// muted icon when denied/unsupported. Uses lucide-react SVGs so the glyph
// matches the rest of the UI instead of an emoji that renders differently
// per OS.
import { Bell, BellOff } from "lucide-react";
import PillButton from "@/components/common/pill-button";
import { useNotifications } from "@/hooks/use-notifications";

export default function NotificationButton() {
  const { state, enable } = useNotifications();

  if (state === "unsupported") return null;

  const title =
    state === "granted"
      ? "Notifications enabled — click to refresh the subscription"
      : state === "denied"
      ? "Notifications blocked — enable in browser settings"
      : "Enable notifications";

  const Icon = state === "denied" ? BellOff : Bell;

  // Clickable in every state except "denied" (browser-level block, cannot be
  // re-prompted from JS). Granted re-subscribes silently, default prompts.
  return (
    <PillButton
      variant={state === "granted" ? "toggle-active" : "toggle"}
      title={title}
      aria-label="Notifications"
      onClick={() => { void enable(); }}
      disabled={state === "denied"}
    >
      <Icon size={16} strokeWidth={2} />
    </PillButton>
  );
}
